import { render, staticRenderFns } from "./CadastrarEditarPerfilDialog.vue?vue&type=template&id=f8edf162&scoped=true"
import script from "./CadastrarEditarPerfilDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarPerfilDialog.vue?vue&type=script&lang=js"
import style0 from "./CadastrarEditarPerfilDialog.vue?vue&type=style&index=0&id=f8edf162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8edf162",
  null
  
)

export default component.exports